export default __webpack_public_path__ + "static/media/checkbox-selected-blue.46a9d3c7.svg";